import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ConditionalSpinner } from 'components/Spinner';
import styles from './MenuDropdownComponents.module.scss';

const MenuDropdownSpinner = ({ isLoading, loadingText, className, children, ...rest }) => (
    <ConditionalSpinner
        inline
        {...rest}
        active={isLoading}
        text={loadingText}
        outerTag="li"
        className={cx(styles.spinner, className)}
    >
        {children}
    </ConditionalSpinner>
);

MenuDropdownSpinner.displayName = 'MenuDropdownSpinner';

MenuDropdownSpinner.propTypes = {
    isLoading: PropTypes.bool,
    loadingText: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
};

MenuDropdownSpinner.defaultProps = {
    isLoading: false,
    loadingText: null,
    className: null,
    children: null,
};

export default MenuDropdownSpinner;
